import { getTranslations } from "@/lib/translations";

import { requireStaff } from "@/core/auth/admin-guard";
import { createGooglePlacesService } from "@/core/services/factory";
import type {
  GooglePlacesAutocompleteResult,
  GooglePlacesDetailsResult,
} from "@/core/services/types/google-places.types";

async function mapAutocompleteError(
  error: string,
  t: ReturnType<typeof getTranslations>,
): Promise<string> {
  if (error === "missing_api_key") return t("apiKeyMissing");
  return t("searchFailed");
}

async function mapDetailsError(
  error: string,
  t: ReturnType<typeof getTranslations>,
): Promise<string> {
  if (error === "missing_api_key") return t("apiKeyMissing");
  return t("detailsFailed");
}

export async function searchGooglePlaces(
  query: string,
): Promise<GooglePlacesAutocompleteResult> {
  await requireStaff();

  const t = getTranslations("places.edit.googleSearch");
  const result = await createGooglePlacesService().autocomplete(query);

  if (!result.success) {
    return {
      success: false,
      error: await mapAutocompleteError(result.error, t),
    };
  }

  return result;
}

export async function fetchGooglePlaceDetails(
  placeId: string,
): Promise<GooglePlacesDetailsResult> {
  await requireStaff();

  const t = getTranslations("places.edit.googleSearch");
  const result = await createGooglePlacesService().getPlaceDetails(placeId);

  if (!result.success) {
    return {
      success: false,
      error: await mapDetailsError(result.error, t),
    };
  }

  return result;
}
